var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/tools/viewmodels/index',["require", "exports", "common/viewmodelbase", "services/navigator", "models/portal"], function (require, exports, Common, Navigator, Portal) {
    "use strict";
    var ToolsViewModel = (function (_super) {
        __extends(ToolsViewModel, _super);
        function ToolsViewModel() {
            _super.call(this);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.title = "Tools";
            //ko.track(this, [""]); 
        }
        ToolsViewModel.prototype.wkappstoreClick = function () {
            Navigator.navigateTo("wkappstore", "index", "/wkappstore", null);
        };
        ToolsViewModel.prototype.iServeClick = function () {
            // calledFromTools - flag to see if iServe is called from Tools
            var calledFromTools = true;
            Navigator.navigateTo("iServe", "index", "/i-Serve", JSON.stringify(calledFromTools));
        };
        return ToolsViewModel;
    }(Common.ViewModelBase));
    var instance = new ToolsViewModel();
    return instance;
});

